(function () {
  const initAsideMenu = () => {
    const header = document.querySelector(".header-wrapper");
    const asideMenu = document.querySelector(".aside-menu");
    const openAsideMenuBtn = document.querySelector(".aside-menu__toggle--open-btn");
    const closeMenuBtn = document.querySelector(".aside-menu__toggle--full-close-btn");
    const closeAsideMenuBtn = document.querySelector(".aside-menu__toggle--close-btn");
    const asideMenuOverlay = document.querySelector(".aside-menu__overlay");

    const firstLevelItems = document.querySelectorAll(".first_level_details");
    const secondLevelItems = document.querySelectorAll(".second_level_details");
    const firstLevelToggles = document.querySelectorAll(".aside-menu__toggle--close-btn");

    if (header) header.preventHide = false;

    const openAsideMenu = (e) => {
      e.preventDefault();
      if (header) header.preventHide = true;
      asideMenu.classList.add("aside-menu--open");
      asideMenuOverlay.classList.add("aside-menu__overlay--active");
      document.body.classList.add("overflow-hidden-aside");
    };

    const closeAsideMenu = (e) => {
      if (e) e.preventDefault();
      asideMenu.classList.remove("aside-menu--open");
      asideMenuOverlay.classList.remove("aside-menu__overlay--active");
      document.body.classList.remove("overflow-hidden-aside");

      [...firstLevelItems, ...secondLevelItems].forEach((item) => {
        if (item.classList.contains("active")) {
          item.classList.remove("active");
          item.classList.add("hiding");
          setTimeout(() => item.classList.remove("hiding"), 800);
        }
      });

      if (header) header.preventHide = false;
    };

    // 1階層目および2階層目のメインロジック
    firstLevelItems.forEach((item) => {
      const trigger = item.querySelector(".menu-trigger");
      if (!trigger) return;

      trigger.addEventListener("click", (e) => {
        // 2階層目のリンクエリアをクリックした場合は、1階層目の開閉処理を無視
        if (e.target.closest('.aside-menu__submenu')) return;

        const isActive = item.classList.contains("active");

        firstLevelItems.forEach((other) => {
          if (other !== item && other.classList.contains("active")) {
            other.classList.remove("active");
            other.classList.add("hiding");
            setTimeout(() => other.classList.remove("hiding"), 800);
          }
        });

        if (!isActive) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
          item.classList.add("hiding");
          setTimeout(() => item.classList.remove("hiding"), 800);
        }
      });

      // 2階層目の中にある各項目の処理
      const subItems = item.querySelectorAll(".second_level_details");
      subItems.forEach((subItem) => {
        const subTrigger = subItem.querySelector(".menu-trigger");
        if (!subTrigger) return;

        subTrigger.addEventListener("click", (e) => {
          // 下の階層（3階層目）があるか確認
          const hasNextLevel = subItem.querySelector('ul, .aside-menu__submenu');
          
          if (!hasNextLevel) {
            // 下の階層がない「純粋なリンク」の場合：
            // 親要素のクリックイベントを止め、JSでの開閉処理を行わず、ブラウザの遷移に任せる
            e.stopPropagation();
            return; 
          }

          // 下の階層がある場合：
          e.preventDefault();
          e.stopPropagation();
          const isSubActive = subItem.classList.contains("active");

          subItems.forEach((otherSub) => {
            if (otherSub !== subItem && otherSub.classList.contains("active")) {
              otherSub.classList.remove("active");
              otherSub.classList.add("hiding");
              setTimeout(() => otherSub.classList.remove("hiding"), 800);
            }
          });

          if (!isSubActive) {
            subItem.classList.add("active");
          } else {
            subItem.classList.remove("active");
            subItem.classList.add("hiding");
            setTimeout(() => subItem.classList.remove("hiding"), 800);
          }
        });
      });
    });

    // 戻るボタンの処理
    firstLevelToggles.forEach((toggleButton) => {
      toggleButton.addEventListener("click", (e) => {
        e.stopPropagation();
        const parentItem = toggleButton.closest(".first_level_details, .second_level_details");
        if (parentItem) {
          parentItem.classList.remove("active");
          parentItem.classList.add("hiding");
          setTimeout(() => parentItem.classList.remove("hiding"), 800);
        }
      });
    });

    if (openAsideMenuBtn) openAsideMenuBtn.addEventListener("click", openAsideMenu);
    if (closeAsideMenuBtn) closeAsideMenuBtn.addEventListener("click", closeAsideMenu);
    if (asideMenuOverlay) asideMenuOverlay.addEventListener("click", closeAsideMenu);
    if (closeMenuBtn) closeMenuBtn.addEventListener("click", closeAsideMenu);

    asideMenu.addEventListener("keydown", (e) => {
      if (e.code === "Escape") closeAsideMenu(e);
    });
  };

  document.addEventListener("shopify:section:load", initAsideMenu);
  initAsideMenu();
})();